/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerService } from './PartnerService';
import {
    PartnerServiceFromJSON,
    PartnerServiceFromJSONTyped,
    PartnerServiceToJSON,
    PartnerServiceToJSONTyped,
} from './PartnerService';

/**
 * 
 * @export
 * @interface GetPartnerServicesResponse
 */
export interface GetPartnerServicesResponse {
    /**
     * 
     * @type {Array<PartnerService>}
     * @memberof GetPartnerServicesResponse
     */
    partnerServices: Array<PartnerService>;
}

/**
 * Check if a given object implements the GetPartnerServicesResponse interface.
 */
export function instanceOfGetPartnerServicesResponse(value: object): value is GetPartnerServicesResponse {
    if (!('partnerServices' in value) || value['partnerServices'] === undefined) return false;
    return true;
}

export function GetPartnerServicesResponseFromJSON(json: any): GetPartnerServicesResponse {
    return GetPartnerServicesResponseFromJSONTyped(json, false);
}

export function GetPartnerServicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPartnerServicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerServices': ((json['partnerServices'] as Array<any>).map(PartnerServiceFromJSON)),
    };
}

export function GetPartnerServicesResponseToJSON(json: any): GetPartnerServicesResponse {
    return GetPartnerServicesResponseToJSONTyped(json, false);
}

export function GetPartnerServicesResponseToJSONTyped(value?: GetPartnerServicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerServices': ((value['partnerServices'] as Array<any>).map(PartnerServiceToJSON)),
    };
}

